module.exports = __webpack_public_path__ + "img/55-green.4d36a71c.svg";